export const LOADING = 'BV_LOADING';
export const LOADED = 'BV_LOADED';
